// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* =============================================
=         Design System Color Palette         =
============================================= */
.styles_color__2rZkm.styles_ocean-50__T\\+B3u {
  color: #e6f2ff;
}

.styles_color__2rZkm.styles_ocean-100__BMv6E {
  color: #e6f2ff;
}

.styles_color__2rZkm.styles_ocean-200__vpK\\+K {
  color: #b3daff;
}

.styles_color__2rZkm.styles_ocean-300__oGDDC {
  color: #7abfff;
}

.styles_color__2rZkm.styles_ocean-400__44fun {
  color: #2392fb;
}

.styles_color__2rZkm.styles_ocean-500__lWZ7T {
  color: #0074e0;
}

.styles_color__2rZkm.styles_ocean-600__qrtsa {
  color: #043571;
}

.styles_color__2rZkm.styles_space-50__RJzST {
  color: #f0f0f0;
}

.styles_color__2rZkm.styles_space-100__\\+7ife {
  color: #e3e3e3;
}

.styles_color__2rZkm.styles_space-200__LGJbY {
  color: #bfbfbf;
}

.styles_color__2rZkm.styles_space-300__MjPoK {
  color: gray;
}

.styles_color__2rZkm.styles_space-400__uITxi {
  color: #616161;
}

.styles_color__2rZkm.styles_space-500__lQ-u9 {
  color: #283439;
}

.styles_color__2rZkm.styles_gray-50__lMQ6O {
  color: #eff3f6;
}

.styles_color__2rZkm.styles_gray-100__1V0It {
  color: #e6ecef;
}

.styles_color__2rZkm.styles_gray-200__TSjqQ {
  color: #cfd8de;
}

.styles_color__2rZkm.styles_gray-300__uEOmy {
  color: #a8b9c2;
}

.styles_color__2rZkm.styles_gray-400__VUlhf {
  color: #7e98a5;
}

.styles_color__2rZkm.styles_gray-500__vwnt6 {
  color: #738f9c;
}

.styles_color__2rZkm.styles_green-50__gW7u9 {
  color: #e3fdf6;
}

.styles_color__2rZkm.styles_green-100__FW7JX {
  color: #c5f6ea;
}

.styles_color__2rZkm.styles_green-200__ITdsK {
  color: #69ddc2;
}

.styles_color__2rZkm.styles_green-300__MpGMC {
  color: #45bfa3;
}

.styles_color__2rZkm.styles_green-400__d2weg {
  color: #1cab8a;
}

.styles_color__2rZkm.styles_green-500__PmNMG {
  color: #128268;
}

.styles_color__2rZkm.styles_red-50__V2wvj {
  color: #fff0f3;
}

.styles_color__2rZkm.styles_red-100__Fgft0 {
  color: #f9d2db;
}

.styles_color__2rZkm.styles_red-200__fmcDl {
  color: #f8b4c4;
}

.styles_color__2rZkm.styles_red-300__r\\+pfV {
  color: #e85e81;
}

.styles_color__2rZkm.styles_red-400__JOFWW {
  color: #e23661;
}

.styles_color__2rZkm.styles_red-500__ZOLTP {
  color: #b82348;
}

.styles_color__2rZkm.styles_yellow-50__Sjyl1 {
  color: #fffae6;
}

.styles_color__2rZkm.styles_yellow-100__42bKQ {
  color: #fff0b3;
}

.styles_color__2rZkm.styles_yellow-200__IhJub {
  color: #ffe380;
}

.styles_color__2rZkm.styles_yellow-300__amVVA {
  color: #ffcf57;
}

.styles_color__2rZkm.styles_yellow-400__9eOzj {
  color: #ffc60a;
}

.styles_color__2rZkm.styles_yellow-500__3TNSb {
  color: #ffb700;
}

.styles_color__2rZkm.styles_orange-50__7QzNK {
  color: #fff2eb;
}

.styles_color__2rZkm.styles_orange-100__Kzw\\+0 {
  color: #ffe4d6;
}

.styles_color__2rZkm.styles_orange-200__vXuyr {
  color: #ffc69e;
}

.styles_color__2rZkm.styles_orange-300__soVxB {
  color: #ffa047;
}

.styles_color__2rZkm.styles_orange-400__5XsY1 {
  color: #ff7b42;
}

.styles_color__2rZkm.styles_orange-500__ljsFj {
  color: #ee4920;
}

.styles_color__2rZkm.styles_turquoise-50__JGB1h {
  color: transparent;
}

.styles_color__2rZkm.styles_turquoise-100__SS8Q- {
  color: #e6fcff;
}

.styles_color__2rZkm.styles_turquoise-200__SsO0Q {
  color: #b3f5ff;
}

.styles_color__2rZkm.styles_turquoise-300__TMy26 {
  color: #78e2f2;
}

.styles_color__2rZkm.styles_turquoise-400__goM2p {
  color: #00c7e6;
}

.styles_color__2rZkm.styles_turquoise-500__x\\+lxJ {
  color: transparent;
}

.styles_color__2rZkm.styles_turquoise-600__\\+B2tx {
  color: transparent;
}

.styles_color__2rZkm.styles_violet-50__ikmF1 {
  color: #eae6ff;
}

.styles_color__2rZkm.styles_violet-100__my5eV {
  color: #d9d1ff;
}

.styles_color__2rZkm.styles_violet-200__NKPiu {
  color: #bfb3ff;
}

.styles_color__2rZkm.styles_violet-300__Z7Dia {
  color: #9d90ea;
}

.styles_color__2rZkm.styles_violet-400__NvF8v {
  color: #8678d9;
}

.styles_color__2rZkm.styles_violet-500__CJDHA {
  color: #6f5ccc;
}

.styles_color__2rZkm.styles_snow-50__bqnnp {
  color: white;
}

.styles_color__2rZkm.styles_snow-100__BlDak {
  color: #f7f7f7;
}

.styles_color__2rZkm.styles_snow-200__xFZdi {
  color: #f0efef;
}

.styles_color__2rZkm.styles_snow-300__CZSXe {
  color: #e6e6e6;
}

.styles_color__2rZkm.styles_snow-400__txJWm {
  color: #e1e0e0;
}

.styles_color__2rZkm.styles_snow-500__gKV3u {
  color: #cfcfcf;
}

/* =============================================
=              Background Colors              =
============================================= */
.styles_background-color__OAXD1.styles_ocean__4KN\\+9 {
  background-color: #2392fb;
  color: white;
}

.styles_background-color__OAXD1.styles_ocean-light__F17-G {
  background-color: #b3daff;
  color: white;
}

.styles_background-color__OAXD1.styles_green__v398P {
  background-color: #1cab8a;
  color: white;
}

.styles_background-color__OAXD1.styles_green-light__P84tm {
  background-color: #69ddc2;
  color: white;
}

.styles_background-color__OAXD1.styles_red__Ce93I {
  background-color: #e23661;
  color: white;
}

.styles_background-color__OAXD1.styles_red-light__u9xch {
  background-color: #f8b4c4;
  color: white;
}

.styles_background-color__OAXD1.styles_orange__r9jH9 {
  background-color: #ff7b42;
  color: white;
}

.styles_background-color__OAXD1.styles_orange-light__TyUCU {
  background-color: #ffc69e;
  color: white;
}

.styles_background-color__OAXD1.styles_space__mPw6n {
  background-color: #616161;
  color: white;
}

.styles_background-color__OAXD1.styles_space-light__sIQQ8 {
  background-color: #bfbfbf;
  color: #616161;
}

.styles_background-color__OAXD1.styles_gray-light__km-vD {
  background-color: #f0efef;
  color: #616161;
}

.styles_background-color__OAXD1.styles_violet__gXlgy {
  background-color: #8678d9;
  color: white;
}

.styles_background-color__OAXD1.styles_violet-light__D8Jiy {
  background-color: #bfb3ff;
  color: #616161;
}

.styles_background-color__OAXD1.styles_yellow__S1MmD {
  background-color: #ffc60a;
  color: white;
}

.styles_background-color__OAXD1.styles_yellow-light__o\\+Xlt {
  background-color: #ffe380;
  color: #616161;
}

/* The "blur" parameter (the third one) for drop shadow is rendered twice as in the box shadow.
 * So we have to divide it by 2 to have the same output as box shadows.
*/
.styles_root__R84rk {
  border-radius: 5px;
  height: 4px;
  overflow: hidden;
  width: 100%;
}
.styles_root__R84rk .styles_bar__qKNy7 {
  animation: styles_progress-animation__jw\\+Cv 5s linear infinite;
  background: linear-gradient(270deg, #3f7fe5 0%, #3f7fe5 25%, #6fd1c9 25%, #6fd1c9 50%, #7891f3 50%, #7891f3 75%, #f4b963 75%, #f4b963 95%, #3f7fe5 95%, #3f7fe5 100%);
  background-size: 300% 100%;
  display: block;
  height: 100%;
}

@keyframes styles_progress-animation__jw\\+Cv {
  0% {
    background-position: 300%;
  }
  100% {
    background-position: 0;
  }
}`, "",{"version":3,"sources":["webpack://./src/ui-kit/styles/_theme/_colors.scss","webpack://./src/ui-kit/components/loading-indicator-bar/styles.module.scss","webpack://./src/ui-kit/styles/_theme/_shadows.scss"],"names":[],"mappings":"AAEA;;+CAAA;AAmFI;EACI,cAjFC;ACAT;;ADgFI;EACI,cAjFC;ACIT;;AD4EI;EACI,cAjFC;ACQT;;ADwEI;EACI,cAjFC;ACYT;;ADoEI;EACI,cAjFC;ACgBT;;ADgEI;EACI,cAjFC;ACoBT;;AD4DI;EACI,cAjFC;ACwBT;;ADwDI;EACI,cAjFC;AC4BT;;ADoDI;EACI,cAjFC;ACgCT;;ADgDI;EACI,cAjFC;ACoCT;;AD4CI;EACI,WAjFC;ACwCT;;ADwCI;EACI,cAjFC;AC4CT;;ADoCI;EACI,cAjFC;ACgDT;;ADgCI;EACI,cAjFC;ACoDT;;AD4BI;EACI,cAjFC;ACwDT;;ADwBI;EACI,cAjFC;AC4DT;;ADoBI;EACI,cAjFC;ACgET;;ADgBI;EACI,cAjFC;ACoET;;ADYI;EACI,cAjFC;ACwET;;ADQI;EACI,cAjFC;AC4ET;;ADII;EACI,cAjFC;ACgFT;;ADAI;EACI,cAjFC;ACoFT;;ADJI;EACI,cAjFC;ACwFT;;ADRI;EACI,cAjFC;AC4FT;;ADZI;EACI,cAjFC;ACgGT;;ADhBI;EACI,cAjFC;ACoGT;;ADpBI;EACI,cAjFC;ACwGT;;ADxBI;EACI,cAjFC;AC4GT;;AD5BI;EACI,cAjFC;ACgHT;;ADhCI;EACI,cAjFC;ACoHT;;ADpCI;EACI,cAjFC;ACwHT;;ADxCI;EACI,cAjFC;AC4HT;;AD5CI;EACI,cAjFC;ACgIT;;ADhDI;EACI,cAjFC;ACoIT;;ADpDI;EACI,cAjFC;ACwIT;;ADxDI;EACI,cAjFC;AC4IT;;AD5DI;EACI,cAjFC;ACgJT;;ADhEI;EACI,cAjFC;ACoJT;;ADpEI;EACI,cAjFC;ACwJT;;ADxEI;EACI,cAjFC;AC4JT;;AD5EI;EACI,cAjFC;ACgKT;;ADhFI;EACI,cAjFC;ACoKT;;ADpFI;EACI,cAjFC;ACwKT;;ADxFI;EACI,kBAjFC;AC4KT;;AD5FI;EACI,cAjFC;ACgLT;;ADhGI;EACI,cAjFC;ACoLT;;ADpGI;EACI,cAjFC;ACwLT;;ADxGI;EACI,cAjFC;AC4LT;;AD5GI;EACI,kBAjFC;ACgMT;;ADhHI;EACI,kBAjFC;ACoMT;;ADpHI;EACI,cAjFC;ACwMT;;ADxHI;EACI,cAjFC;AC4MT;;AD5HI;EACI,cAjFC;ACgNT;;ADhII;EACI,cAjFC;ACoNT;;ADpII;EACI,cAjFC;ACwNT;;ADxII;EACI,cAjFC;AC4NT;;AD5II;EACI,YAjFC;ACgOT;;ADhJI;EACI,cAjFC;ACoOT;;ADpJI;EACI,cAjFC;ACwOT;;ADxJI;EACI,cAjFC;AC4OT;;AD5JI;EACI,cAjFC;ACgPT;;ADhKI;EACI,cAjFC;ACoPT;;AD/JA;;+CAAA;AA8EI;EALA,yBAAA;EACA,YAAA;AC6FJ;;ADzFI;EALA,yBAAA;EACA,YAAA;ACkGJ;;AD9FI;EALA,yBAAA;EACA,YAAA;ACuGJ;;ADnGI;EALA,yBAAA;EACA,YAAA;AC4GJ;;ADxGI;EALA,yBAAA;EACA,YAAA;ACiHJ;;AD7GI;EALA,yBAAA;EACA,YAAA;ACsHJ;;ADlHI;EALA,yBAAA;EACA,YAAA;AC2HJ;;ADvHI;EALA,yBAAA;EACA,YAAA;ACgIJ;;AD5HI;EALA,yBAAA;EACA,YAAA;ACqIJ;;ADjII;EALA,yBAAA;EACA,cAAA;AC0IJ;;ADtII;EALA,yBAAA;EACA,cAAA;AC+IJ;;AD3II;EALA,yBAAA;EACA,YAAA;ACoJJ;;ADhJI;EALA,yBAAA;EACA,cAAA;ACyJJ;;ADrJI;EALA,yBAAA;EACA,YAAA;AC8JJ;;AD1JI;EALA,yBAAA;EACA,cAAA;ACmKJ;;ACtTA;;CAAA;ADdA;EACI,kBAAA;EACA,WAAA;EACA,gBAAA;EACA,WAAA;AA0UJ;AAxUI;EACI,+DAAA;EAGA,qKACI;EAaJ,0BAAA;EACA,cAAA;EACA,YAAA;AA2TR;;AAvTA;EACI;IACI,yBAAA;EA0TN;EAvTE;IACI,sBAAA;EAyTN;AACF","sourcesContent":["@use 'sass:map';\n\n/* =============================================\n=         Design System Color Palette         =\n============================================= */\n$colors: (\n    // ocean\n    ocean-50: hsla(210, 100%, 95%, 1),\n    ocean-100: hsla(210, 100%, 95%, 1),\n    ocean-200: hsla(209, 100%, 85%, 1),\n    ocean-300: hsla(209, 100%, 74%, 1),\n    ocean-400: hsla(209, 96%, 56%, 1),\n    ocean-500: hsla(209, 100%, 44%, 1),\n    ocean-600: hsla(213, 93%, 23%, 1),\n    // space\n    space-50: hsla(0, 0%, 94%, 1),\n    space-100: hsla(0, 0%, 89%, 1),\n    space-200: hsla(0, 0%, 75%, 1),\n    space-300: hsla(0, 0%, 50%, 1),\n    space-400: hsla(0, 0%, 38%, 1),\n    space-500: hsla(198, 18%, 19%, 1),\n    // gray\n    gray-50: hsla(200, 27%, 95%, 1),\n    gray-100: hsla(200, 21%, 92%, 1),\n    gray-200: hsla(201, 18%, 84%, 1),\n    gray-300: hsla(201, 18%, 71%, 1),\n    gray-400: hsla(200, 18%, 57%, 1),\n    gray-500: hsl(199, 17%, 53%, 1),\n    // green\n    green-50: hsla(164, 85%, 94%, 1),\n    green-100: hsla(165, 74%, 87%, 1),\n    green-200: hsla(166, 63%, 64%, 1),\n    green-300: hsla(166, 49%, 51%, 1),\n    green-400: hsla(166, 72%, 39%, 1),\n    green-500: hsla(166, 76%, 29%, 1),\n    // red\n    red-50: hsla(346, 100%, 97%, 1),\n    red-100: hsla(346, 76%, 90%, 1),\n    red-200: hsla(346, 83%, 84%, 1),\n    red-300: hsla(345, 75%, 64%, 1),\n    red-400: hsla(345, 75%, 55%, 1),\n    red-500: hsla(345, 68%, 43%, 1),\n    // yellow\n    yellow-50: hsla(48, 100%, 95%, 1),\n    yellow-100: hsla(48, 100%, 85%, 1),\n    yellow-200: hsla(47, 100%, 75%, 1),\n    yellow-300: hsla(43, 100%, 67%, 1),\n    yellow-400: hsla(46, 100%, 52%, 1),\n    yellow-500: hsla(43, 100%, 50%, 1),\n    // orange\n    orange-50: hsla(21, 100%, 96%, 1),\n    orange-100: hsla(21, 100%, 92%, 1),\n    orange-200: hsla(25, 100%, 81%, 1),\n    orange-300: hsla(29, 100%, 64%, 1),\n    orange-400: hsla(18, 100%, 63%, 1),\n    orange-500: hsla(12, 86%, 53%, 1),\n    // turquoise\n    turquoise-50: transparent, // TODO: update this value when it got defined on the designs\n    turquoise-100: hsla(187, 100%, 95%, 1),\n    turquoise-200: hsla(188, 100%, 85%, 1),\n    turquoise-300: hsla(188, 82%, 71%, 1),\n    turquoise-400: hsla(188, 100%, 45%, 1),\n    turquoise-500: transparent, // TODO: update this value when it got defined on the designs\n    turquoise-600: transparent, // TODO: update this value when it got defined on the designs\n    // violet\n    violet-50: hsla(250, 100%, 95%, 1),\n    violet-100: hsla(250, 100%, 91%, 1),\n    violet-200: hsla(250, 100%, 85%, 1),\n    violet-300: hsla(249, 68%, 74%, 1),\n    violet-400: hsla(249, 56%, 66%, 1),\n    violet-500: hsla(250, 52%, 58%, 1),\n    // snow\n    snow-50: hsla(0, 0%, 100%, 1),\n    snow-100: hsla(0, 0%, 97%, 1),\n    snow-200: hsla(0, 3%, 94%, 1),\n    snow-300: hsla(0, 0%, 90%, 1),\n    snow-400: hsla(0, 1%, 88%, 1),\n    snow-500: hsla(0, 0%, 81%, 1),\n);\n\n@function color($color) {\n    @return map.get($colors, $color);\n}\n\n@each $name, $color in $colors {\n    .color.#{$name} {\n        color: $color;\n    }\n}\n\n/* =============================================\n=              Background Colors              =\n============================================= */\n$background-colors: (\n    ocean: (\n        color: color(ocean-400),\n        contrast-color: color(snow-50),\n    ),\n    ocean-light: (\n        color: color(ocean-200),\n        contrast-color: color(snow-50),\n    ),\n    'green': (\n        color: color(green-400),\n        contrast-color: color(snow-50),\n    ),\n    green-light: (\n        color: color(green-200),\n        contrast-color: color(snow-50),\n    ),\n    'red': (\n        color: color(red-400),\n        contrast-color: color(snow-50),\n    ),\n    red-light: (\n        color: color(red-200),\n        contrast-color: color(snow-50),\n    ),\n    'orange': (\n        color: color(orange-400),\n        contrast-color: color(snow-50),\n    ),\n    orange-light: (\n        color: color(orange-200),\n        contrast-color: color(snow-50),\n    ),\n    space: (\n        color: color(space-400),\n        contrast-color: color(snow-50),\n    ),\n    space-light: (\n        color: color(space-200),\n        contrast-color: color(space-400),\n    ),\n    gray-light: (\n        color: color(snow-200),\n        contrast-color: color(space-400),\n    ),\n    'violet': (\n        color: color(violet-400),\n        contrast-color: color(snow-50),\n    ),\n    violet-light: (\n        color: color(violet-200),\n        contrast-color: color(space-400),\n    ),\n    'yellow': (\n        color: color(yellow-400),\n        contrast-color: color(snow-50),\n    ),\n    yellow-light: (\n        color: color(yellow-200),\n        contrast-color: color(space-400),\n    ),\n);\n\n@function get-background-color($color-name) {\n    @return map.get($background-colors, $color-name);\n}\n\n@mixin background-color($name) {\n    $colors: get-background-color($name);\n\n    background-color: map.get($colors, color);\n    color: map.get($colors, contrast-color);\n}\n\n@each $name in map-keys($background-colors) {\n    .background-color.#{$name} {\n        @include background-color($name);\n    }\n}\n","@use 'sass:color';\n@use '~$app-web/ui-kit/styles/theme';\n\n.root {\n    border-radius: theme.get-border-radius(md);\n    height: 4px;\n    overflow: hidden;\n    width: 100%;\n\n    .bar {\n        animation: progress-animation 5s linear infinite;\n\n        // TODO: change these colors to our Design System color palette.\n        background:\n            linear-gradient(\n                270deg,\n                rgba(63, 127, 229, 1) 0%,\n                rgba(63, 127, 229, 1) 25%,\n                rgba(111, 209, 201, 1) 25%,\n                rgba(111, 209, 201, 1) 50%,\n                rgba(120, 145, 243, 1) 50%,\n                rgba(120, 145, 243, 1) 75%,\n                rgba(244, 185, 99, 1) 75%,\n                rgba(244, 185, 99, 1) 95%,\n                rgba(63, 127, 229, 1) 95%,\n                rgba(63, 127, 229, 1) 100%\n            );\n        background-size: 300% 100%;\n        display: block;\n        height: 100%;\n    }\n}\n\n@keyframes progress-animation {\n    0% {\n        background-position: 300%;\n    }\n\n    100% {\n        background-position: 0;\n    }\n}\n","@use 'sass:map';\n@use 'sass:string';\n\n$shadow-base-color: rgb(9, 30, 66);\n$second-shadow-color: rgba($shadow-base-color, 0.31);\n\n// TODO-MAYBE: Use our design system color palette colors.\n$box-shadows: (\n    sm: (0 1px 1px rgba($shadow-base-color, 0.25), 0 0 1px $second-shadow-color),\n    md: (0 3px 5px rgba($shadow-base-color, 0.2), 0 0 1px $second-shadow-color),\n    lg: (0 8px 12px rgba($shadow-base-color, 0.15), 0 0 1px $second-shadow-color),\n    xl: (0 18px 28px rgba($shadow-base-color, 0.15), 0 0 1px $second-shadow-color),\n    // TODO: These are not correct. They should be fixed when the values are fixed in Figma.\n    right: 0 0 20px rgba(73, 73, 73, 0.3),\n    left: 0 0 20px rgba(73, 73, 73, 0.3),\n);\n\n/* The \"blur\" parameter (the third one) for drop shadow is rendered twice as in the box shadow.\n * So we have to divide it by 2 to have the same output as box shadows.\n*/\n$drop-shadows: (\n    sm: (drop-shadow(0 1px 0.5px rgba($shadow-base-color, 0.25)) drop-shadow(0 0 0.5px $second-shadow-color)),\n    md: (drop-shadow(0 3px 2.5px rgba($shadow-base-color, 0.2)) drop-shadow(0 0 0.5px $second-shadow-color)),\n    lg: (drop-shadow(0 8px 6px rgba($shadow-base-color, 0.15)) drop-shadow(0 0 0.5px $second-shadow-color)),\n    xl: (drop-shadow(0 18px 14px rgba($shadow-base-color, 0.15)) drop-shadow(0 0 0.5px $second-shadow-color)),\n);\n\n@function box-shadow($shadow: sm) {\n    @return map.get($box-shadows, $shadow);\n}\n\n@function drop-shadow($shadow: sm) {\n    @return map.get($drop-shadows, $shadow);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"color": `styles_color__2rZkm`,
	"ocean-50": `styles_ocean-50__T+B3u`,
	"ocean-100": `styles_ocean-100__BMv6E`,
	"ocean-200": `styles_ocean-200__vpK+K`,
	"ocean-300": `styles_ocean-300__oGDDC`,
	"ocean-400": `styles_ocean-400__44fun`,
	"ocean-500": `styles_ocean-500__lWZ7T`,
	"ocean-600": `styles_ocean-600__qrtsa`,
	"space-50": `styles_space-50__RJzST`,
	"space-100": `styles_space-100__+7ife`,
	"space-200": `styles_space-200__LGJbY`,
	"space-300": `styles_space-300__MjPoK`,
	"space-400": `styles_space-400__uITxi`,
	"space-500": `styles_space-500__lQ-u9`,
	"gray-50": `styles_gray-50__lMQ6O`,
	"gray-100": `styles_gray-100__1V0It`,
	"gray-200": `styles_gray-200__TSjqQ`,
	"gray-300": `styles_gray-300__uEOmy`,
	"gray-400": `styles_gray-400__VUlhf`,
	"gray-500": `styles_gray-500__vwnt6`,
	"green-50": `styles_green-50__gW7u9`,
	"green-100": `styles_green-100__FW7JX`,
	"green-200": `styles_green-200__ITdsK`,
	"green-300": `styles_green-300__MpGMC`,
	"green-400": `styles_green-400__d2weg`,
	"green-500": `styles_green-500__PmNMG`,
	"red-50": `styles_red-50__V2wvj`,
	"red-100": `styles_red-100__Fgft0`,
	"red-200": `styles_red-200__fmcDl`,
	"red-300": `styles_red-300__r+pfV`,
	"red-400": `styles_red-400__JOFWW`,
	"red-500": `styles_red-500__ZOLTP`,
	"yellow-50": `styles_yellow-50__Sjyl1`,
	"yellow-100": `styles_yellow-100__42bKQ`,
	"yellow-200": `styles_yellow-200__IhJub`,
	"yellow-300": `styles_yellow-300__amVVA`,
	"yellow-400": `styles_yellow-400__9eOzj`,
	"yellow-500": `styles_yellow-500__3TNSb`,
	"orange-50": `styles_orange-50__7QzNK`,
	"orange-100": `styles_orange-100__Kzw+0`,
	"orange-200": `styles_orange-200__vXuyr`,
	"orange-300": `styles_orange-300__soVxB`,
	"orange-400": `styles_orange-400__5XsY1`,
	"orange-500": `styles_orange-500__ljsFj`,
	"turquoise-50": `styles_turquoise-50__JGB1h`,
	"turquoise-100": `styles_turquoise-100__SS8Q-`,
	"turquoise-200": `styles_turquoise-200__SsO0Q`,
	"turquoise-300": `styles_turquoise-300__TMy26`,
	"turquoise-400": `styles_turquoise-400__goM2p`,
	"turquoise-500": `styles_turquoise-500__x+lxJ`,
	"turquoise-600": `styles_turquoise-600__+B2tx`,
	"violet-50": `styles_violet-50__ikmF1`,
	"violet-100": `styles_violet-100__my5eV`,
	"violet-200": `styles_violet-200__NKPiu`,
	"violet-300": `styles_violet-300__Z7Dia`,
	"violet-400": `styles_violet-400__NvF8v`,
	"violet-500": `styles_violet-500__CJDHA`,
	"snow-50": `styles_snow-50__bqnnp`,
	"snow-100": `styles_snow-100__BlDak`,
	"snow-200": `styles_snow-200__xFZdi`,
	"snow-300": `styles_snow-300__CZSXe`,
	"snow-400": `styles_snow-400__txJWm`,
	"snow-500": `styles_snow-500__gKV3u`,
	"background-color": `styles_background-color__OAXD1`,
	"ocean": `styles_ocean__4KN+9`,
	"ocean-light": `styles_ocean-light__F17-G`,
	"green": `styles_green__v398P`,
	"green-light": `styles_green-light__P84tm`,
	"red": `styles_red__Ce93I`,
	"red-light": `styles_red-light__u9xch`,
	"orange": `styles_orange__r9jH9`,
	"orange-light": `styles_orange-light__TyUCU`,
	"space": `styles_space__mPw6n`,
	"space-light": `styles_space-light__sIQQ8`,
	"gray-light": `styles_gray-light__km-vD`,
	"violet": `styles_violet__gXlgy`,
	"violet-light": `styles_violet-light__D8Jiy`,
	"yellow": `styles_yellow__S1MmD`,
	"yellow-light": `styles_yellow-light__o+Xlt`,
	"root": `styles_root__R84rk`,
	"bar": `styles_bar__qKNy7`,
	"progress-animation": `styles_progress-animation__jw+Cv`
};
export default ___CSS_LOADER_EXPORT___;
